import React, { useState, useEffect } from 'react'
import { apiUnbookmarkEvent } from '../api/api'
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import placeholder from '../img/placeholder.png'
import {Col, Row} from 'react-bootstrap'
import BookmarkIcon from '@mui/icons-material/Bookmark';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './HomeCard.css'

const HomeCard = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUnbookmark = (id) =>  {
    apiUnbookmarkEvent(id)
    .then((result) => {
      console.log(result);
      window.location.reload();
    })
    };
    return (
      
      <div className='homeCard'>  
        <Card sx={{ width: 225 }}>
          
          <CardMedia
            component="img"
            height="100"
            image={props.imageUrl}
          />
        <CardContent>
          <Typography gutterBottom variant="h7" component="div">
            <Row>
            <Col style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
            <Link to={`/${props.type}/${props.url}`} style={{color: 'black', 
            textDecoration: 'none'}}> 
            <p className='cardGroupName'>
              {props.groupName}
            </p>
            </Link>
            </Col>
            {props.admin == "isAdmin"?
            <Col xs={2}> 
            <StarIcon style={{float:"right"}}/>
            </Col>
            :
            null
            }
            {props.type == "event"? 
            <Col xs={3}>
            <button>
            <BookmarkIcon sx={{ width: 25, ml: 1 }} onClick={handleClickOpen}/>
            </button>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
              <DialogTitle id="alert-dialog-title">
                {"Unbookmark"}
              </DialogTitle>
              <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to unbookmark {props.groupName} ?
              </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={() => {handleUnbookmark(props.url)}}>Confirm</Button>
              </DialogActions>
              </Dialog>
            </Col>
            :
            null
            }
            </Row>
            
          </Typography>
        </CardContent>
        </Card> 
      </div>
    );
  }

HomeCard.defaultProps = {
  groupName : "Group Name",
  type : "",
  url : "",
  imageUrl : placeholder,
  admin: "notAdmin"
}
  export default HomeCard